import React, { useContext } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { ThemeContext } from '../../context/ThemeContext';

function ThemeSwitcher({ compact = false }) {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <div className={`theme-switcher ${compact ? 'is-compact' : ''}`} role="group" aria-label="Colour theme">
      <button type="button" className={theme === 'light' ? 'is-active' : ''} onClick={() => setTheme('light')} aria-pressed={theme === 'light'} title="Use light theme">
        <FaSun /><span>Light</span>
      </button>
      <button type="button" className={theme === 'dark' ? 'is-active' : ''} onClick={() => setTheme('dark')} aria-pressed={theme === 'dark'} title="Use dark theme">
        <FaMoon /><span>Dark</span>
      </button>
    </div>
  );
}

export default ThemeSwitcher;
